import {Component, OnInit, ChangeDetectionStrategy, Input, ChangeDetectorRef} from '@angular/core';

@Component({
  selector: 'gen-options-button',
  templateUrl: './options-button.component.html',
  styleUrls: ['./options-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OptionsButtonComponent implements OnInit {
  @Input() options: Array<{ label: string, command: () => void }>;
  @Input() buttonText: string;
  @Input() outSideClickClose:boolean;
  @Input() buttonIconClass: string;
  private _disabled: boolean = false;
  @Input()
  set disabled(disabled: boolean) {
    this._disabled = disabled;
    if (this._disabled) {
      this.active = false;
    }
    this.cd.markForCheck();
  }

  get disabled() {
    return this._disabled;
  }

  public active: boolean = false;

  constructor(
    private cd: ChangeDetectorRef,
  ) {
  }

  ngOnInit() {
  }

  trackByFn(item, index) {
    return item ? item.label : index;
  }

  closeOptions($event) {
    if($event.srcElement && $event.target && this.active) {
      this.active = false;
      return this.active;
    }
  }
}
